import {Typography} from '@mui/material';
import {Box} from '@mui/system';

interface IProps {
	children: string | JSX.Element | JSX.Element[];
	title?: string;
	action?: string | JSX.Element | JSX.Element[];
	className?: string;
}

export default function Card({children, title, action, className}: IProps) {
	
	return (
		<div className={`flex flex-col space-y-1 ${className}`}>
			{
				title && <Box
					sx={{
						backgroundColor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : theme.palette.grey['A700'],
						borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.grey['A400']
					}}
					className="flex px-4 justify-between items-center rounded-t border h-10">
					<Typography className="font-medium">{title}</Typography>
					{action}
				</Box>
			}
			<Box
				sx={{
					backgroundColor: (theme) => theme.palette.mode === 'light' ? 'secondary.a200' : 'background.paper',
					borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : theme.palette.grey[700]
				}}
				className="rounded-b border">
				{children}
			</Box>
		</div>
	);
}
